module.exports = __webpack_public_path__ + "img/ic_check_box.24e2ce11.svg";